import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import axios from "axios";

import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.css";

if (process.env.NODE_ENV === "production") {
  axios.defaults.baseURL = "https://hyperbolemur.azurewebsites.net";
}

ReactDOM.render(<App />, document.getElementById("root"));
